/** @module Auth0VerifyEmailPageHelper */
/* eslint-disable import/extensions */
import { Auth0PageBase } from './auth0-page-template.mst.mjs';
import Auth0Localizer from '../../utils/auth0-localization-helper.mjs';
import VerifyEmailHtml from '../../../public/verifyEmalAddress.html.mst';
import Auth0HttpHelper from '../../utils/auth0-http-helper.mjs';
import Auth0Cdn from '../utils/auth0-cdn-resource-resolver.mst.mjs';
import Auth0Constants from '../../utils/auth0-constants.mjs';

class Auth0VerifyEmailPageHelper extends Auth0PageBase {
  constructor(options) {
    super(options);
    console.log(`Auth0VerifyEmailPageHelper => ${JSON.stringify(options)}`);

    this._pageStyles = [
      `${Auth0Cdn.AUTH0_STYLES_URL}/auth0-verify-email-styles.css?cb=71c5d67`,
    ];
  }

  get _verifyStateIconElement() { return document.getElementById('status-image'); }

  get _successIconUrl() {
    return `${Auth0Cdn.AUTH0_IMAGES_URL}/${Auth0Constants.GENERIC_OK_ICON}`;
  }

  get _failIconUrl() {
    return `${Auth0Cdn.AUTH0_IMAGES_URL}/${Auth0Constants.GENERIC_ERROR_ICON}`;
  }

  _verify = async () => {
    // extract the token verify url from current location
    const verifyUrl = this._qs.get('ticketUrl');
    if (!verifyUrl) {
      this._verifyEmailFail('verify-email-fail-ticket-missing');
      return;
    }

    console.log(`_verify => ${verifyUrl}`);

    try {
      await Auth0HttpHelper.post({
        url: verifyUrl,
        contextKey: 'verify-email-fail',
      });
      // success
      this._verifyEmailSuccess();
    } catch (error) {
      console.log(`_verify => ${error.message}`);
      this._verifyEmailFail();
    }
  };

  _verifyEmailSuccess = () => {
    // always display success (even if just briefly)
    console.log('_verifyEmailSuccess start');
    this._verifyStateIconElement.src = this._successIconUrl;
    Auth0Localizer.setElementLocalizedText({ id: 'status-text', resourceIdOverride: 'verify-email-success' });

    // this page may or may not have a redirect url; if it does, redirect to it:
    const redirectUrl = this._qs.get('redirectUrl');
    if (redirectUrl) {
      console.log(`_verifyEmailSuccess redirecting to => ${redirectUrl}`);
      window.location.href = redirectUrl;
    }
  };

  _verifyEmailFail = (messageKey = null) => {
    // icon
    console.log('_verifyEmailFail start');
    this._verifyStateIconElement.src = this._failIconUrl;

    const errorKey = messageKey || 'verify-email-fail';
    Auth0Localizer.setElementLocalizedText({
      id: 'status-text',
      resourceIdOverride: errorKey,
    }, {
      supportEmail: this._whiteLabelHelper.appLoginSupportEmail,
      supportPhoneNumber: this._whiteLabelHelper.appLoginSupportPhoneNumber,
    });
  };

  _localize = async () => {
    await super._localize();

    Auth0Localizer.setElementLocalizedText('verify-email-banner-text');
  };

  _initVerifyEmailHtml = async () => {
    console.log('_initVerifyEmailHtml start');
    await this._localize();
    await this._applyWhiteLabel(this._whiteLabelOptions);
    this._showPage();
  };

  _cancelVerifyEmail = () => {
    console.log('_cancelVerifyEmail start =>', this._appLoginUrl);
    window.location.href = this._appLoginUrl;
  };

  async _onLoad() {
    await super._onLoad();
    // called when render of underlying template is complete

    this.toolbarVisible = true;
    this.actionLinkVisible = true;
    this.actionLinkText = Auth0Localizer.getLocalizedText('toolbar-action-cancel');
    this.actionLinkTextHandler = this._cancelVerifyEmail;

    await this.setBody(VerifyEmailHtml);
  }

  /**
   * @function
   * @async
   * @description Directs the `Auth0LinkingPageHelper` to start the linking process. A valid SSO Identity Provider auth must have already happened before this page loads.
   */
  async _startUi() {
    await super._startUi();
    await this._initVerifyEmailHtml();
    await this._verify();
  }
}

export { Auth0VerifyEmailPageHelper };
